import { createUseStyles } from 'react-jss'
import { LightTheme } from '../../theme'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  productAvatar: {
    objectFit: 'cover'
  },
  title: {
    marginLeft: 16,
    width: 300
  },
  line: {
    padding: '12px 0px',
    '&:not(:first-child)': {
      marginTop: 16
    }
  },
  observeOptionsBtn: {
    marginTop: 12,
    padding: '8px 6px'
  },
  column: {
    maxWidth: 260
  },
  infoRow: {},
  delivery: {
    wordBreak: 'break-word'
  },
  button: {
    marginLeft: 24,
    width: '100%'
  },
  buttonBorder: {
    width: '100%',
    padding: '12px 6px'
  },
  buttonsRow: {
    width: '100%',
    marginTop: 24
  },
  '@media screen and (max-width: 480px)': {
    title: {
      width: '100%'
    },
    line: {
      width: 'calc(100% - 32px)',
      padding: 16,
      backgroundColor: theme.colors.vendorProfileFon
    },
    infoRow: {
      marginTop: 24,
      justifyContent: 'space-around'
    }
  }
}))
